import React from 'react';
import Helmet from 'react-helmet';

import FontLight from '../../fonts/november-pro-light.woff2';
import FontRegular from '../../fonts/november-pro-regular.woff2';
import FontMedium from '../../fonts/november-pro-medium.woff2';
import FontBold from '../../fonts/november-pro-bold.woff2';
import FontHeavy from '../../fonts/november-pro-heavy.woff2';
import FontBlack from '../../fonts/november-pro-black.woff2';

const PreloadEssentials: React.FC = () => {
  return (
    <Helmet>
      <link rel="preload" as="font" crossOrigin="anonymous" href={FontLight} type="font/woff2" />
      <link rel="preload" as="font" crossOrigin="anonymous" href={FontRegular} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={FontMedium} type="font/woff2" />
      <link rel="preload" as="font" crossOrigin="anonymous" href={FontBold} type="font/woff2" />
      <link rel="preload" as="font" crossOrigin="anonymous" href={FontHeavy} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={FontBlack} type="font/woff2" />
    </Helmet>
  );
};

export default PreloadEssentials;
